/*
 * Copyright (c) 2021. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import z from 'zod';
export const batteryEnclosureTypes = ['DC Block', 'AC Block'];
export const cellSuppliers = [
    'Panasonic',
    'BYD',
    'CALB',
    'CATL',
    'PATL',
    'EVE',
    'EVLO',
    'Farasis',
    'FREYR',
    'Gotion',
    'Hithium',
    'Kokam',
    'Kore Power',
    'Leclanche',
    'LG Chem',
    'Lishen',
    'Narada',
    'Risen',
    'REPT',
    'Saft',
    'Samsung SDI',
    'SKI',
    'Toshiba',
    'Trina',
    'Tesla',
];
export const essOperatingEnvelopeSchema = z.object({
    cycles_per_year: z.number().int().min(0),
    resting_soc: z.number().min(0).max(1),
    depth_of_discharge: z.number().min(0).max(1),
    c_rate: z.number().min(0).max(5),
});
//# sourceMappingURL=battery.js.map